import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
// Object path
import * as objectPath from "object-path";
// Services
import { MenuConfigService } from "./menu-config.service";
import { Keywords } from "src/app/enums/kewords.enum";
// import { CustomerService } from "../login.service";

@Injectable({
  providedIn: "root"
})
export class MenuAsideService {
  // Public properties
  menuList$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  permissionsList : string [] = [];
  /**
   * Service constructor
   *
   * @param menuConfigService: MenuConfigService
   */
  constructor(
    private menuConfigService: MenuConfigService,
    // private customerService : CustomerService
    ) {
    this.loadMenu();
  }

  /**
   * Load menu list
   */
  loadMenu() {
    // get menu list
    const menuItems: any[] = objectPath.get(
      this.menuConfigService.getMenus(),
      "aside.items"
    );
    this.menuList$.next(menuItems);
    this.applyPermissionOnMenuItems(this.menuList$.value);
  }

  applyPermissionOnMenuItems(menuList : any []) : any {
    this.permissionsList = JSON.parse(sessionStorage.getItem(Keywords.USER_PERMISSIONS));
    menuList.forEach((menuItem : any)=> {
        menuItem['allowed'] = this.checkIfIsAllowed(menuItem)
    });
  }

  checkIfIsAllowed(menuItem) : boolean {
    let allowed = false;
    if(!menuItem.permissions){
      allowed = true;
    } // static permission 
    else {
      menuItem.permissions.forEach((permission : string) => {
        if(this.permissionsList.includes(permission))
          allowed = true
        if(menuItem.submenu){
          menuItem.submenu.forEach(submenuItem => {
            let subAllowed = this.checkIfIsAllowed(submenuItem)
            submenuItem['allowed'] = subAllowed;
          });
        }
      });
    }
    return allowed;
  }

}
